<white-card>
  {{ labelKey | translate }}
</white-card>